<template>
  <div>
    <v-card class="ma-2">
      <v-card-title>
        NHL Fantasy Player Props
        <v-spacer></v-spacer>

        <v-col cols="12" md="4" sm="5">
          <v-row justify="center" align="center">
            <small>Confidence :</small> <br/>&nbsp;
            <v-col class="light-green caption text-center"
            ><span>Low </span></v-col
            >
            <v-col class="medium-green caption text-center"
            ><span>Medium </span></v-col
            >
            <v-col class="dark-green caption text-center"
            ><span>High </span></v-col
            >
          </v-row>
        </v-col>
        <v-spacer></v-spacer>

        <v-col cols="12" md="5" sm="3">
          <v-row align="center" justify="end">
            <!--            <v-col md="7" cols="7" sm="6">-->
            <!--              <v-text-field-->
            <!--                v-model="search"-->
            <!--                append-icon="mdi-magnify"-->
            <!--                label="Search Player"-->
            <!--                single-line-->
            <!--                dense-->
            <!--                outlined-->
            <!--                hide-details-->
            <!--              ></v-text-field>-->
            <!--            </v-col>-->

            <v-col cols="5" md="4" sm="3">
              <v-card-actions>
                <v-switch v-model="switch1" inset label="Props"></v-switch>
                <!--                 <v-switch-->
                <!--                class="px-2"-->
                <!--                v-model="switch2"-->
                <!--                :disabled="switch1 ? false : true"-->
                <!--                inset-->
                <!--                label="Confidence"-->
                <!--                @change="enableConfidence"-->
                <!--                ></v-switch>-->
              </v-card-actions>
            </v-col>
          </v-row>
        </v-col>
      </v-card-title>

      <!-- <v-row class="mt-n8" justify="center">
        <v-col cols="2" md="1" sm="6" align-self="center">
          <v-avatar size="36px">
            <img alt="Avatar" src="/favicon.ico" />
          </v-avatar>
        </v-col>
        <v-col cols="3" md="1" sm="6" align-self="center">
          <span>Projection</span>
        </v-col>

        <v-col cols="2" md="1" sm="6">
          <v-avatar size="36px">
            <img alt="Avatar" src="/img/monkeyKnife.jpeg" />
          </v-avatar>
        </v-col>

        <v-col cols="3" md="1" sm="6" align-self="center">
          <span>Prop Line</span>
        </v-col>
      </v-row> -->

      <v-card-subtitle class="overline font-weight-bold">
        Players
      </v-card-subtitle>

      <v-data-table
          :headers="computedOtherHeaders"
          :items="computedTableData"
          :items-per-page="10"
          class="elevation-1 projection-table"
          mobile-breakpoint="0"
          calculate-widths
          sort-by="Name"
          :search="search"
          hide-default-footer
      >
        <!-- header -->
        <template
            v-for="(h, index) in computedOtherHeaders"
            v-slot:[`header.${h.value}`]="{ computedOtherHeaders }"
        >
          <span class="team-w-mg" :key="h.text" v-if="h.img">
            <span>{{ h.text }}</span>
            <v-avatar size="20"> <img :src="h.img"/></v-avatar>
          </span>

          <span class="team-w-mg" v-else :key="index">{{ h.text }}</span>
        </template>
        <!-- header -->

        <!-- date -->
        <template v-slot:item.DateTime="{ item }">
          <p>{{ item.DateTime | DatetimeFormat }}</p>
        </template>

        <!--//* matchup -->
        <template v-slot:item.Game="{ item }">
          <p class="body-2" v-if="item.HomeOrAway == 'HOME'">
            {{ item.Opponent }}&nbsp;
            <small class="black--text">@</small>
            <span>
              {{ item.Team }}
            </span>
          </p>

          <p class="body-2" v-if="item.HomeOrAway == 'AWAY'">
            {{ item.Team }}&nbsp;
            <small class="black--text">@</small>
            <span>
              {{ item.Opponent }}
            </span>
          </p>
        </template>
        <!--//* matchup ends -->

        <template v-slot:item.ProfilePic="{ item }">
          <!-- //* avatar -->
          <v-avatar width="35" height="40">
            <img :src="item.ProfilePic"/>
          </v-avatar>
          <!-- //* avatar ends-->
        </template>

        <!-- Goals -->
        <template v-slot:item.CalGoals="{ item }">
          <p v-if="item.CalGoals == ''">_</p>
          <p v-else>{{ parseFloat(item.CalGoals).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceGoal="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalGoals) >= 0 && parseFloat(item.CalGoals) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalGoals) >= 15 && parseFloat(item.CalGoals) <= 33
            "
          >
            Over
          </p>

          <p class="dark-green" v-else-if="parseFloat(item.CalGoals) >= 33">
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalGoals) < 0 && parseFloat(item.CalGoals) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalGoals) <= -15 &&
              parseFloat(item.CalGoals) >= -33
            "
          >
            Under
          </p>

          <p class="dark-green" v-else-if="parseFloat(item.CalGoals) < -33">
            Under
          </p>
        </template>

        <!-- Assists -->

        <template v-slot:item.CalAssists="{ item }">
          <p v-if="item.CalAssists == ''">_</p>
          <p v-else>{{ parseFloat(item.CalAssists).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceAssist="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalAssists) >= 0 &&
              parseFloat(item.CalAssists) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalAssists) >= 15 &&
              parseFloat(item.CalAssists) <= 33
            "
          >
            Over
          </p>

          <p class="dark-green" v-else-if="parseFloat(item.CalAssists) >= 33">
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalAssists) < 0 &&
              parseFloat(item.CalAssists) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalAssists) <= -15 &&
              parseFloat(item.CalAssists) >= -33
            "
          >
            Under
          </p>

          <p class="dark-green" v-else-if="parseFloat(item.CalAssists) < -33">
            Under
          </p>
        </template>

        <!-- ShotsOnGoal -->
        <template v-slot:item.CalShotsOnGoal="{ item }">
          <p v-if="item.CalShotsOnGoal == ''">_</p>
          <p v-else>{{ parseFloat(item.CalShotsOnGoal).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceShots="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalShotsOnGoal) >= 0 &&
              parseFloat(item.CalShotsOnGoal) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalShotsOnGoal) >= 15 &&
              parseFloat(item.CalShotsOnGoal) <= 33
            "
          >
            Over
          </p>

          <p
              class="dark-green"
              v-else-if="parseFloat(item.CalShotsOnGoal) >= 33"
          >
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalShotsOnGoal) < 0 &&
              parseFloat(item.CalShotsOnGoal) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalShotsOnGoal) <= -15 &&
              parseFloat(item.CalShotsOnGoal) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="parseFloat(item.CalShotsOnGoal) < -33"
          >
            Under
          </p>
        </template>

        <!-- FantasyPoints -->
        <template v-slot:item.CalFantasyPoints="{ item }">
          <p v-if="item.CalFantasyPoints == ''">_</p>
          <p v-else>{{ parseFloat(item.CalFantasyPoints).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceFantasyPoints="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalFantasyPoints) >= 0 &&
              parseFloat(item.CalFantasyPoints) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) >= 15 &&
              parseFloat(item.CalFantasyPoints) <= 33
            "
          >
            Over
          </p>

          <p
              class="dark-green"
              v-else-if="parseFloat(item.CalFantasyPoints) >= 33"
          >
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) < 0 &&
              parseFloat(item.CalFantasyPoints) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) <= -15 &&
              parseFloat(item.CalFantasyPoints) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="parseFloat(item.CalFantasyPoints) < -33"
          >
            Under
          </p>
        </template>

        <!--Points  -->
        <template v-slot:item.CalPoints="{ item }">
          <p v-if="item.CalPoints == ''">_</p>
          <p v-else>{{ parseFloat(item.CalPoints).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidencePoints="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalPoints) >= 0 && parseFloat(item.CalPoints) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalPoints) >= 15 &&
              parseFloat(item.CalPoints) <= 33
            "
          >
            Over
          </p>

          <p class="dark-green" v-else-if="parseFloat(item.CalPoints) >= 33">
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalPoints) < 0 &&
              parseFloat(item.CalPoints) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalPoints) <= -15 &&
              parseFloat(item.CalPoints) >= -33
            "
          >
            Under
          </p>

          <p class="dark-green" v-else-if="parseFloat(item.CalPoints) < -33">
            Under
          </p>
        </template>
      </v-data-table>

      <!--//? Goalies  -->
      <v-card-subtitle class="overline font-weight-bold">
        Goalies
      </v-card-subtitle>
      <v-data-table
          :headers="computedGoaliesHeaders"
          :items="computedGoaliesData"
          :items-per-page="10"
          class="elevation-1 projection-table"
          mobile-breakpoint="0"
          calculate-widths
          sort-by="Name"
          :search="search"
          hide-default-footer
      >
        <!-- header -->
        <template
            v-for="(h, index) in computedGoaliesHeaders"
            v-slot:[`header.${h.value}`]="{ computedGoaliesHeaders }"
        >
          <span class="team-w-mg" :key="h.text" v-if="h.img">
            <span>{{ h.text }}</span>
            <v-avatar size="20"> <img :src="h.img"/></v-avatar>
          </span>

          <span class="team-w-mg" v-else :key="index">{{ h.text }}</span>
        </template>
        <!-- header -->

        <!-- date -->
        <template v-slot:item.DateTime="{ item }">
          <p>{{ item.DateTime | DatetimeFormat }}</p>
        </template>

        <template v-slot:item.ProfilePic="{ item }">
          <!-- //* avatar -->
          <v-avatar width="35" height="40">
            <img :src="item.ProfilePic"/>
          </v-avatar>
          <!-- //* avatar ends-->
        </template>

        <!--//* matchup -->
        <template v-slot:item.Game="{ item }">
          <p class="body-2" v-if="item.HomeOrAway == 'HOME'">
            {{ item.Opponent }}&nbsp;
            <small class="black--text">@</small>
            <span>
              {{ item.Team }}
            </span>
          </p>

          <p class="body-2" v-if="item.HomeOrAway == 'AWAY'">
            {{ item.Team }}&nbsp;
            <small class="black--text">@</small>
            <span>
              {{ item.Opponent }}
            </span>
          </p>
        </template>
        <!--//* matchup ends -->

        <!-- saves -->
        <template v-slot:item.CalGoaltendingSaves="{ item }">
          <p v-if="item.CalGoaltendingSaves == ''">_</p>
          <p v-else>{{ parseFloat(item.CalGoaltendingSaves).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceSave="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalGoaltendingSaves) >= 0 &&
              parseFloat(item.CalGoaltendingSaves) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalGoaltendingSaves) >= 15 &&
              parseFloat(item.CalGoaltendingSaves) <= 33
            "
          >
            Over
          </p>

          <p
              class="dark-green"
              v-else-if="parseFloat(item.CalGoaltendingSaves) >= 33"
          >
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalGoaltendingSaves) < 0 &&
              parseFloat(item.CalGoaltendingSaves) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalGoaltendingSaves) <= -15 &&
              parseFloat(item.CalGoaltendingSaves) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="parseFloat(item.CalGoaltendingSaves) < -33"
          >
            Under
          </p>
        </template>

        <!-- goals against -->
        <template v-slot:item.CalGoaltendingGoalsAgainst="{ item }">
          <p v-if="item.CalGoaltendingGoalsAgainst == ''">_</p>
          <p v-else>
            {{ parseFloat(item.CalGoaltendingGoalsAgainst).toFixed(2) }}%
          </p>
        </template>

        <template v-slot:item.confidenceGoalsAgainst="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalGoaltendingGoalsAgainst) >= 0 &&
              parseFloat(item.CalGoaltendingGoalsAgainst) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalGoaltendingGoalsAgainst) >= 15 &&
              parseFloat(item.CalGoaltendingGoalsAgainst) <= 33
            "
          >
            Over
          </p>

          <p
              class="dark-green"
              v-else-if="parseFloat(item.CalGoaltendingGoalsAgainst) >= 33"
          >
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalGoaltendingGoalsAgainst) < 0 &&
              parseFloat(item.CalGoaltendingGoalsAgainst) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalGoaltendingGoalsAgainst) <= -15 &&
              parseFloat(item.CalGoaltendingGoalsAgainst) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="parseFloat(item.CalGoaltendingGoalsAgainst) < -33"
          >
            Under
          </p>
        </template>

        <!-- fantasy points -->

        <template v-slot:item.CalFantasyPoints="{ item }">
          <p v-if="item.CalFantasyPoints == ''">_</p>
          <p v-else>{{ parseFloat(item.CalFantasyPoints).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceFantasyPoints="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalFantasyPoints) >= 0 &&
              parseFloat(item.CalFantasyPoints) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) >= 15 &&
              parseFloat(item.CalFantasyPoints) <= 33
            "
          >
            Over
          </p>

          <p
              class="dark-green"
              v-else-if="parseFloat(item.CalFantasyPoints) >= 33"
          >
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) < 0 &&
              parseFloat(item.CalFantasyPoints) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) <= -15 &&
              parseFloat(item.CalFantasyPoints) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="parseFloat(item.CalFantasyPoints) < -33"
          >
            Under
          </p>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "NhlDemoProjection",
  data() {
    return {
      switch1: true,
      UpgradeModal: false,
      search: "",
      // switch2: false,
      OtherHeader: [
        {
          text: "",
          value: "ProfilePic",
          sortable: false,
          width: "70",
        },
        {
          text: "Player Name",
          value: "Name",
          width: "150",
        },
        {
          text: "Opp",
          value: "Game",
          width: "120",
        },

        {
          text: "Date",
          value: "DateTime",
          width: "150",
        },

        // *
        {
          text: "Goals",
          value: "FantasyGoals",
          width: "110",
          img: "/favicon.ico",
        },

        {
          text: "O/U",
          value: "MonkeyGoals",
          // img: '/img/monkeyKnife.jpeg',
        },

        {
          text: "% Diff",
          value: "CalGoals",
        },

        {
          text: "Confidence",
          value: "confidenceGoal",
          sortable: false,
          width: "130",
        },

        // *
        {
          text: "Assists",
          value: "FantasyAssists",
          img: "/favicon.ico",
          width: "110",
          class: "black--text",
        },

        {
          text: "O/U",
          value: "MonkeyAssists",
          // img: '/img/monkeyKnife.jpeg',
          width: "110",
          class: "black--text",
        },

        {
          text: "% Diff",
          value: "CalAssists",
          width: "110",
          class: "black--text",
        },

        {
          text: "Confidence",
          value: "confidenceAssist",
          sortable: false,
          width: "130",
          class: "black--text",
        },

        // *
        {
          text: "Shots on Goal",
          value: "FantasyShotsOnGoal",
          width: "110",
          img: "/favicon.ico",
        },

        {
          text: "O/U",
          value: "MonkeyShotsOnGoal",
          width: "110",
          // img: '/img/monkeyKnife.jpeg',
        },

        {
          text: "% Diff",
          value: "CalShotsOnGoal",
          width: "110",
        },

        {
          text: "Confidence",
          sortable: false,
          value: "confidenceShots",
          width: "130",
        },

        // *
        {
          text: "Fantasy Points",
          value: "FantasyFantasyPoints",
          width: "100",
          img: "/favicon.ico",
          class: "black--text",
        },

        {
          text: "O/U",
          value: "MonkeyFantasyPoints",
          width: "100",
          // img: '/img/monkeyKnife.jpeg',
          class: "black--text",
        },

        {
          text: "% Diff",
          value: "CalFantasyPoints",
          width: "110",
          class: "black--text",
        },

        {
          text: "Confidence",
          value: "confidenceFantasyPoints",
          width: "130",
          class: "black--text",
        },

        // *
        {
          text: "Points",
          value: "FantasyPoints",
          width: "100",
          img: "/favicon.ico",
          class: "black--text",
        },

        {
          text: "O/U",
          value: "MonkeyPoints",
          width: "100",
          // img: '/img/monkeyKnife.jpeg',
          class: "black--text",
        },

        {
          text: "% Diff",
          value: "CalPoints",
          width: "110",
          class: "black--text",
        },

        {
          text: "Confidence",
          value: "confidencePoints",
          width: "130",
          class: "black--text",
        },
      ],

      goaliesHeader: [
        {
          text: "",
          value: "ProfilePic",
          sortable: false,
          width: "70",
        },
        {
          text: "Player Name",
          value: "Name",
          width: "150",
        },
        {
          text: "Opp",
          value: "Game",
          width: "120",
        },

        {
          text: "Date",
          value: "DateTime",
          width: "150",
        },

        // *
        {
          text: "Saves",
          value: "FantasyGoaltendingSaves",
          img: "/favicon.ico",
          width: "110",
          class: "black--text",
        },

        {
          text: "O/U",
          value: "MonkeyGoaltendingSaves",
          // img: '/img/monkeyKnife.jpeg',
          width: "110",
          class: "black--text",
        },

        {
          text: "% Diff",
          value: "CalGoaltendingSaves",
          width: "110",
          class: "black--text",
        },

        {
          text: "Confidence",
          value: "confidenceSave",
          sortable: false,
          width: "130",
          class: "black--text",
        },

        // *
        {
          text: "Goals Against",
          value: "FantasyGoaltendingGoalsAgainst",
          width: "110",
          img: "/favicon.ico",
        },

        {
          text: "O/U",
          value: "MonkeyGoaltendingGoalsAgainst",
          width: "110",
          // img: '/img/monkeyKnife.jpeg',
        },

        {
          text: "% Diff",
          value: "CalGoaltendingGoalsAgainst",
          width: "110",
        },

        {
          text: "Confidence",
          sortable: false,
          value: "confidenceGoalsAgainst",
          width: "130",
        },

        // *
        {
          text: "Fantasy Points",
          value: "FantasyFantasyPoints",
          width: "100",
          img: "/favicon.ico",
          class: "black--text",
        },

        {
          text: "O/U",
          value: "MonkeyFantasyPoints",
          width: "100",
          // img: '/img/monkeyKnife.jpeg',
          class: "black--text",
        },

        {
          text: "% Diff",
          value: "CalFantasyPoints",
          width: "110",
          class: "black--text",
        },

        {
          text: "Confidence",
          value: "confidenceFantasyPoints",
          width: "130",
          class: "black--text",
        },
      ],
    };
  },

  computed: {
    ...mapState("NhlModule", ["nhl_props"]),
    ...mapState("userModule", ["userState"]),

    computedOtherHeaders() {
      if (this.switch1) {
        return this.OtherHeader;
      } else if (!this.switch1) {
        let newHeader = this.OtherHeader.filter((column) => {
          return (
              !column.value.includes("MonkeyGoals") &&
              !column.value.includes("CalGoals") &&
              !column.value.includes("confidenceGoal") &&
              !column.value.includes("MonkeyAssists") &&
              !column.value.includes("CalAssists") &&
              !column.value.includes("confidenceAssist") &&
              !column.value.includes("MonkeyShotsOnGoal") &&
              !column.value.includes("CalShotsOnGoal") &&
              !column.value.includes("confidenceShots") &&
              !column.value.includes("MonkeyFantasyPoints") &&
              !column.value.includes("CalFantasyPoints") &&
              !column.value.includes("confidenceFantasyPoints") &&
              !column.value.includes("MonkeyPoints") &&
              !column.value.includes("CalPoints") &&
              !column.value.includes("confidencePoints")
          );
        });
        return newHeader;
      }
    },

    computedGoaliesHeaders() {
      if (this.switch1) {
        return this.goaliesHeader;
      } else if (!this.switch1) {
        let newHeader = this.goaliesHeader.filter((column) => {
          return (
              !column.value.includes("MonkeyGoaltendingSaves") &&
              !column.value.includes("CalGoaltendingSaves") &&
              !column.value.includes("confidenceSave") &&
              !column.value.includes("MonkeyGoaltendingGoalsAgainst") &&
              !column.value.includes("CalGoaltendingGoalsAgainst") &&
              !column.value.includes("confidenceGoalsAgainst") &&
              !column.value.includes("MonkeyFantasyPoints") &&
              !column.value.includes("CalFantasyPoints") &&
              !column.value.includes("confidenceFantasyPoints")
          );
        });
        return newHeader;
      }
    },

    computedTableData() {
      if (this.nhl_props.teams) {
        return this.nhl_props.teams
            .filter((_player) => {
              return !_player.Position.includes("G");
            })
            .slice(0, 3);
      }
    },

    computedGoaliesData() {
      if (this.nhl_props.teams) {
        return this.nhl_props.teams
            .filter((_player) => {
              return _player.Position.includes("G");
            })
            .slice(0, 3);
      }
    },
  },

  created() {
    this.fetchNhlPropsData();
  },

  beforeMount() {
    if (this.userState) {
      if (this.userState.plantype == "Free") {
        this.UpgradeModal = true;
      } else {
        this.UpgradeModal = false;
      }
    }
  },

  methods: {
    fetchNhlPropsData() {
      this.$store.dispatch("NhlModule/getNhlProps");
    },
    goBack() {
      this.$router.go(-1);
    },

    goToUpgrade() {
      this.$router.push({name: "upgradePlan"});
    },
  },
};
</script>

<style scoped>
.theme--light.v-data-table
>>> .v-data-table__wrapper
> table
> thead
> tr:last-child
> th {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

span.team-w-mg {
  /* display: flex !important; */
  float: left;
}

.theme--light.v-data-table
>>> .v-data-table__wrapper
> table
> thead
> tr:last-child
> th.black--text {
  background-color: #cfd8dc !important;
}

.projection-table >>> .v-data-table-header__icon {
  opacity: 1;
}

.light-green {
  background-clip: #99cc99;
  padding: 5px;
  border-radius: 3px;
  color: white;
  text-align: center;
  font-weight: 800;
}

.medium-green {
  background-color: #33cc66;
  padding: 5px;
  border-radius: 3px;
  color: white;
  text-align: center;
  font-weight: 800;
}

.dark-green {
  background-color: #336633;
  padding: 5px;
  border-radius: 3px;
  color: white;
  text-align: center;
  font-weight: 800;
}
</style>
